import { z } from 'zod';
import { EmailSchema, InviteStatusSchema, TenantRoleSchema, TimestampSchema } from '../common.js';
/**
 * Pending / accepted / revoked / expired invite — see docs/data-model.md §4.3.
 * TTL-expired (default 7 days) and removed by DDB itself.
 */
export const InviteSchema = z.object({
    inviteId: z.string().uuid(),
    tenantId: z.string().uuid(),
    email: EmailSchema,
    role: TenantRoleSchema,
    /** 32 random bytes hex-encoded (64 chars); shared via the invite link, not echoed back to clients. */
    token: z.string().regex(/^[a-f0-9]{64}$/),
    status: InviteStatusSchema,
    /** Cognito sub of the inviter (super-admin or tenant-admin). String form for compat. */
    invitedBy: z.string(),
    invitedByEmail: EmailSchema,
    createdAt: TimestampSchema,
    expiresAt: TimestampSchema,
    /** TTL epoch seconds for DDB to expire the row. */
    ttl: z.number().int().positive(),
});
/**
 * Public lookup payload — returned by GET /v1/invites/{token}.
 * The token itself is NEVER echoed back; only contextual info needed by
 * the dashboard's accept-invite page.
 */
export const InvitePublicSchema = z.object({
    email: EmailSchema,
    tenantName: z.string(),
    role: TenantRoleSchema,
    status: InviteStatusSchema,
    expiresAt: TimestampSchema,
});
/**
 * Subset shown to the inviter after creating an invite.
 * Omits `token`, `tenantId`, `ttl`, `invitedBy`-sub.
 */
export const InviteSummarySchema = InviteSchema.pick({
    inviteId: true,
    email: true,
    role: true,
    status: true,
    expiresAt: true,
    invitedByEmail: true,
    createdAt: true,
});
//# sourceMappingURL=invite.js.map